/** @format */

export const industryNavigationMenu = [
    {
        key: "EzTimeTracking_TimeTracking_Janitorial",
        EzMarketingPageAssetId: 'JANITORIAL',
        title: 'Janitorial',
        link: '/time-tracking/janitorial.html',
        altLink: '/marketing/janitorial.html'
    },
    {
        key: "EzTimeTracking_TimeTracking_Contractors",
        EzMarketingPageAssetId: 'CONTRACTORS',
        title: 'Contractors',
        link: '/time-tracking/contractors.html',
        altLink: '/marketing/contractors.html'
    },
    {
        key: "EzTimeTracking_TimeTracking_LandscapeLawnCare",
        EzMarketingPageAssetId: 'LANDSCAPE_LAWN_CARE',
        title: 'Landscape Lawn Care',
        link: '/time-tracking/landscape-lawncare.html',
        altLink: '/marketing/landscape-lawncare.html'
    },
    {
        key: "EzTimeTracking_TimeTracking_HomeCare",
        EzMarketingPageAssetId: 'HOME_CARE',
        title: 'Home Care',
        link: '/time-tracking/home-care.html',
        altLink: '/marketing/home-care.html'
    },
    {
        key: "EzTimeTracking_TimeTracking_Construction",
        EzMarketingPageAssetId: 'CONSTRUCTION',
        title: 'Construction',
        link: '/time-tracking/construction.html',
        altLink: '/marketing/construction.html'
    },
    {
        key: "EzTimeTracking_TimeTracking_PropertyManagement",
        EzMarketingPageAssetId: 'PROPERTY_MANAGEMENT',
        title: 'Property Management',
        link: '/time-tracking/property-management.html',
        altLink: '/marketing/property-management.html'
    },
    {
        key: "EzTimeTracking_TimeTracking_OtherSmallBusiness",
        EzMarketingPageAssetId: 'SMALL_BUSINESS',
        title: 'Other Small Business',
        link: '/time-tracking/small-business.html',
        altLink: '/marketing/small-business.html'
    },
    {
        key: "EzTimeTracking_TimeTracking_Freelancers",
        EzMarketingPageAssetId: 'FREELANCERS',
        title: 'Freelancers',
        // TODO: Uncomment the link below and remove the active one once the page is moved to the ezclocker-time-tracking-pages
        // link: '/time-tracking/time-clock-for-freelancers.html',
        link: '/time-tracking/time-clock-for-freelancers/index.html',
        // TODO: Uncomment the link below and remove the active one once the page is moved to the ezclocker-time-tracking-pages
        // altLink:'/marketing/time-clock-for-freelancers.html',
        altLink: '/time-tracking/time-clock-for-freelancers/index.html'
    },

];
